import { get } from 'lodash';

import { Form, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { applicantSchema } from '../schemas/applicantSchema';
import { Address } from './FormFields/Address';
import { ControlButtons } from './ControlButtons';
import { PhoneNumber } from './FormFields/PhoneNumber';

// TODO: This component was very coupled to the form stepper, and unfortunately still is
// semi-coupled to the form stepper in many ways, even though it needs to be re-used.
// The method currently in place to allow reuse with the formComponent prop is not ideal
// and was implemented just to get reuse somewhat working. The form stepper handling
// really should be pulled out into its own HOC or something so this can be reconfigured
// as more of a strictly reusable form component.

export const ApplicantInfo = ({
	currApplicant = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	formComponent = false,
	prefix,
	register: registerAsComponent,
	formState: parentFormState,
	autoFocus,
}) => {
	let formState, register;
	const namePrefix = prefix ? prefix + '.' : '';

	const {
		register: standaloneRegister,
		handleSubmit,
		formState: standaloneFormState,
	} = useForm({
		resolver: yupResolver(applicantSchema),
		defaultValues: currApplicant,
	});

	if (formComponent) {
		formState = parentFormState;
		register = registerAsComponent;
	} else {
		formState = standaloneFormState;
		register = standaloneRegister;
	}

	return (
		<Container className="component">
			<Container className="p-0 mt-5 component">
				<h2 className="mb-4">Applicant Contact Information</h2>
				<Form.Group controlId="ApplicantInfoName">
					<Form.Label>Applicant Name</Form.Label>
					<Form.Control
						type="text"
						autoFocus={!formComponent || autoFocus}
						{...register(namePrefix + 'name')}
					/>
					<Form.Text className="text-danger">
						{get(formState.errors, namePrefix + 'name')?.message}
					</Form.Text>
				</Form.Group>

				<Form.Group className="mb-3" controlId="formGridAddress2">
					<Form.Label>Phone Number</Form.Label>
					{/* <Form.Control value={inputValue} onInput={handleInput} placeholder="XXX-XXX-XXXX" {...register('phone')} /> */}

					<PhoneNumber
						register={register}
						registerName={namePrefix + 'phone'}></PhoneNumber>
					<Form.Text className="text-danger">
						{get(formState.errors, namePrefix + 'phone')?.message}
					</Form.Text>
				</Form.Group>

				<Form.Group className="mb-3" controlId="formGridAddress2">
					<Form.Label>Email</Form.Label>
					<Form.Control type="email" {...register(namePrefix + 'email')} />
					<Form.Text className="text-danger">
						{get(formState.errors, namePrefix + 'email')?.message}
					</Form.Text>
				</Form.Group>

				<Address register={register} prefix={prefix} error={formState.errors} />
			</Container>

			{!formComponent && (
				<ControlButtons
					onNext={handleSubmit(onNext)}
					onPrev={onPrevious}
					onSubmit={handleSubmit(onSubmit)}
					disablePrev={disablePrev}
					disableNext={disableNext}
					finalStep={finalStep}></ControlButtons>
			)}
		</Container>
	);
};
